import {Assert} from '@mintdata/mint-kit/impl/util/Assert';
import {StringUtil} from '@mintdata/mint-kit/impl/util/StringUtil';

export interface HasEvents<L>
{
}

type ListenerInfo = {
    listener:any;
    once:boolean;
}

export class EventBus
{
    private static listenerMap:Map<HasEvents<any>, Array<ListenerInfo>> = new Map();

    public static fire(source:HasEvents<any>, eventName:string, ...parameters:Array<any>)
    {
        Assert.yes(source, 'event source should be defined');
        const listenersInfos = this.listenerMap.get(source);
        if( listenersInfos )
        {
            const handlerName = 'on' + StringUtil.capitalizeFirstLetter(eventName, false);
            for( let {listener, once} of listenersInfos )
            {
                const handler = listener[handlerName];
                if( typeof handler === 'function' )
                {
                    listener[handlerName](...parameters);
                    if( once )
                        this.removeListener(source, listener);
                }
            }
        }
    }

    public static listen<L>(source:HasEvents<L>, listener:L)
    {
        this._addListener(source, listener, false);
    }

    public static listenOnce<L>(source:HasEvents<L>, listener:L)
    {
        this._addListener(source, listener, true);
    }

    public static clear(source:HasEvents<any>)
    {
        this.listenerMap.delete(source);
    }

    public static removeListener<L>(source:HasEvents<L>, listener:L)
    {
        const listenersInfos = this.listenerMap.get(source);
        if( listenersInfos )
        {
            while( true )
            {
                let index = listenersInfos.findIndex(info => info.listener === listener);
                if( index === -1 )
                    break;

                listenersInfos.splice(index, 1);
            }
        }
    }

    private static _addListener<L>(source:HasEvents<L>, listener:L, once:boolean)
    {
        const listenerInfo = {listener, once} as ListenerInfo;

        const listeners = this.listenerMap.get(source);
        if( !listeners )
            this.listenerMap.set(source, [listenerInfo]);
        else
            listeners.push(listenerInfo);
    }
}
